// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class PageContextRecord extends Immutable.Record({
  // Defer to global page context values if not specified
  pageName: undefined,
  pageSection: undefined,
  // Override global page context stream meta values
  recBatchId: null,
  recId: null,
  streamId: null,
  streamKey: null,
  streamType: null
}) {
  // No methods
}

PageContextRecord.reviver = keyedReviver(PageContextRecord, {
  // No nested data structures
})

PageContextRecord.propTypes = {
  pageName: PropTypes.string,
  pageSection: PropTypes.string,
  recBatchId: PropTypes.string,
  recId: PropTypes.string,
  streamId: PropTypes.oneOfType([
    PropTypes.string, // url_id
    PropTypes.number // All other ids
  ]),
  streamKey: PropTypes.string,
  streamType: PropTypes.string
}

module.exports = PageContextRecord
